import { useCallback, useEffect, useRef, useState } from "react";
import { createMarkerContent, loadScript, map_settings } from "../../../map";

const Map = ({ job_location }) => {
    const [mapLoaded, setMapLoaded] = useState(false);
    const mapRef = useRef(null);
    const mapInstance = useRef(null); // Store the map instance
    const boundsRef = useRef(null);

    const { latitude, longitude } = job_location;

    useEffect(() => {
        loadScript(
            map_settings.map_script_url,
            () => setMapLoaded(true),
            () => console.error("Failed to load Google Maps script.")
        );
    }, []);

    // Initialize the map
    const initializeMap = useCallback(() => {
        if (mapInstance.current || !window.google || !window.google.maps) {
            return;
        }

        mapInstance.current = new window.google.maps.Map(mapRef.current, {
            center: { lat: parseFloat(latitude), lng: parseFloat(longitude) },
            zoom: 8,
            mapId: "JOB_MAP"
        });

        boundsRef.current = new window.google.maps.LatLngBounds();
    }, [latitude, longitude]);

    // Add markers to the map
    const addMarkers = useCallback(() => {
        if (!mapInstance.current || (!latitude && !longitude)) return;

        const jobLatLng = new window.google.maps.LatLng(parseFloat(latitude), parseFloat(longitude));
        boundsRef.current.extend(jobLatLng);

        new window.google.maps.marker.AdvancedMarkerElement({
            position: jobLatLng,
            content: createMarkerContent(map_settings.customer_map_icon),
            map: mapInstance.current,
            title: `FFFF`,
        });

        // mapInstance.current.fitBounds(boundsRef.current);
        mapInstance.current.setZoom(12); // Set zoom once after bounds are set
    }, [latitude, longitude]);

    // Effect for initializing the map and adding markers
    useEffect(() => {
        if (mapLoaded) {
            initializeMap();
            addMarkers();
        }
    }, [mapLoaded, initializeMap, addMarkers]);

    return(
        <div 
            ref={mapRef} 
            style={{ width: '100%', height: 350 }} 
        />
    );
};

export default Map;